import objectToQuerystring from '@/utils/sfaas_temp/objectToQueryString';
import client from '@/api/client';
import { BASE_URL } from '@/constants';

import moment from 'moment';

export default {
	// custom 코드조회
	async getCommCodeDetails(codeType) {
		try {
			const params = { commCdType: codeType, sqlId: 'customPrCorSql', commCd: '', refCd: '' };
			const queryString =
				'?' +
				Object.entries(params)
					.map(([key, val]) => (!_.isNil(val) ? `${key}=${val}` : ''))
					.filter(r => r)
					.join('&');

			const response = await client.get(`${BASE_URL}/comm/common/custCode/v1/custCodeLists` + queryString);
			return response?.data;
		} catch (error) {
			throw error.response?.data;
		}
	},
	postSearchSelectList: param => {
		return client
			.get(`${BASE_URL}/comm/common/custCode/v1/PcPcmClamCustCodeLists`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},
	getgrdList: ({ searchParams, currentPage, pageUnit }) => {
		let queryStr = '';
		let srchMm01 = searchParams.srchMm01;
		let srchMm02 = searchParams.srchMm02;

		/*날짜 포멧변환*/
		var strtMm01, endMm01, strtMm02, endMm02;

		if (searchParams.strtMm01) {
			strtMm01 = moment(searchParams.strtMm01).format('YYYYMM');
		} else {
			strtMm01 = '';
		}
		if (searchParams.endMm01) {
			endMm01 = moment(searchParams.endMm01).format('YYYYMM');
		} else {
			endMm01 = '';
		}
		if (searchParams.strtMm02) {
			strtMm02 = moment(searchParams.strtMm02).format('YYYYMM');
		} else {
			strtMm02 = '';
		}
		if (searchParams.endMm02) {
			endMm02 = moment(searchParams.endMm02).format('YYYYMM');
		} else {
			endMm02 = '';
		}

		if (searchParams.stdAnls !== undefined) {
			queryStr = objectToQuerystring({
				srchMm01: searchParams.srchMm01, //판매월
				srchMm02: searchParams.srchMm02, //조건월
				partNo: searchParams.partNo, //품번
				idxScn: searchParams.idxScn, //지수구분
				carScn: searchParams.carScn, //차량구분
				pacScn: searchParams.pacScn, //승상구분
				// plntCd: searchParams.plntCd, //생산공장
				flclSpc: searchParams.flclSpc, //연료전지사양
				phmnCd: searchParams.phmnCd, //현상코드
				// customPrCor: searchParams.customPrCor, //생산법인
				ctype: searchParams.ctype, //클레임타입
				useTerm: searchParams.useTerm, //사용기간
				check: searchParams.check, //누적
				// saleNat: searchParams.saleNat, //판매국가
				occuRegn: searchParams.occuRegn, //판매지역
				opCd: searchParams.opCd, //작업코드
				carTypeNm: searchParams.carTypeNm, //차종유형

				strtMm01: strtMm01, //strtMm01
				endMm01: endMm01, //endMm01
				strtMm02: strtMm02, //strtMm02
				endMm02: endMm02, //endMm02
				currentPage,
				pageUnit
			});
		}

		//console.log('queryStr>>>>>', queryStr);

		return client
			.get(`${BASE_URL}/mqy/clma/pcPcmRegn/v1/srchMm01/${srchMm01}/srchMm02/${srchMm02}` + queryStr)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	}
};
